import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const PlanPriceContainer = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  padding: 16px;
  overflow: hidden;
`;

export const PlanHeader = styled.div`
  margin-bottom: 0;
`;

export const CancellationSection = styled.div`
  background: ${theme.smokeWhite};
  border-radius: 8px;
  padding: 12px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CancellationSectionPwa = styled(CancellationSection)`
  height: auto;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
`;

export const CancellationCompactRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-end;
  justify-content: center;
  flex-shrink: 0;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.lightSilver};
  margin: 16px 0;
`;

export const BookingDetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
  padding: 0 12px;
`;
